export default "__VITE_ASSET__c5b8e2be__"